import { Card, CardContent } from "@/components/ui/card";
import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Home Theater Enthusiast",
    content: "Setup took 5 minutes and the 4K quality is incredible! The hardware transcoding makes streaming butter-smooth on all my devices.",
    rating: 5,
    avatar: "SM"
  },
  {
    name: "David Chen",
    role: "Privacy Advocate",
    content: "AI family-safe filters give me peace of mind knowing my kids only see appropriate content. The WebAuthn MFA is a game-changer for security.",
    rating: 5,
    avatar: "DC"
  },
  {
    name: "Maria Rodriguez",
    role: "Plugin Developer",
    content: "Plugin marketplace is a game-changer for customization. I love how easy it is to extend Vewly's functionality with community plugins.",
    rating: 5,
    avatar: "MR"
  }
];

export function TestimonialsSection() {
  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="mb-4 text-3xl font-bold md:text-4xl">
            Loved by Early Adopters
          </h2>
          <p className="text-lg text-muted-foreground">
            Join thousands of users who've already made the switch
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="hover-scale">
              <CardContent className="p-6">
                {/* Rating */}
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 fill-primary text-primary" />
                  ))}
                </div>

                {/* Content */}
                <p className="mb-4 text-muted-foreground italic">
                  "{testimonial.content}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-full bg-primary/20 flex items-center justify-center font-semibold text-primary">
                    {testimonial.avatar}
                  </div>
                  <div>
                    <div className="font-semibold">{testimonial.name}</div>
                    <div className="text-sm text-muted-foreground">
                      {testimonial.role}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Social Proof Stats */}
        <div className="mt-12 grid gap-6 md:grid-cols-4 text-center">
          <div>
            <div className="text-3xl font-bold text-primary mb-2">500+</div>
            <p className="text-sm text-muted-foreground">Active Beta Users</p>
          </div>
          <div>
            <div className="text-3xl font-bold text-primary mb-2">99.5%</div>
            <p className="text-sm text-muted-foreground">Uptime</p>
          </div>
          <div>
            <div className="text-3xl font-bold text-primary mb-2">10k+</div>
            <p className="text-sm text-muted-foreground">Hours Streamed</p>
          </div>
          <div>
            <div className="text-3xl font-bold text-primary mb-2">4.9/5</div>
            <p className="text-sm text-muted-foreground">Average Rating</p>
          </div>
        </div>
      </div>
    </section>
  );
}
